import React from 'react';
import { useContentVisibility } from '../../context/ContentVisibilityContext';
import { CONTENT_VISIBILITY_OPTIONS } from '../../utils/contentVisibility';
const HeaderContentVisibilityChoices = ({ onSelected }) => {
    const { preference, saving, setPreference, } = useContentVisibility();
    return (React.createElement(React.Fragment, null,
        React.createElement("li", { className: "dropdown-header" }, "Content visibility"),
        CONTENT_VISIBILITY_OPTIONS.map((option) => (React.createElement("li", { key: option.value },
            React.createElement("button", { type: "button", className: "btn btn-link wt-user-menu-choice", disabled: saving, onClick: () => {
                    void setPreference(option.value)
                        .then(onSelected)
                        .catch((error) => console.error('Failed to save content visibility:', error));
                } },
                React.createElement("i", { className: `fa ${preference === option.value ? 'fa-check-circle' : 'fa-circle-o'}`, "aria-hidden": "true" }),
                React.createElement("span", null,
                    React.createElement("strong", null, option.label),
                    React.createElement("small", null, option.description))))))));
};
export default HeaderContentVisibilityChoices;
